<template>
  <header class="bg-white">
    <div class="max-w-lg mx-auto px-4 h-14 flex items-center">
      <!-- 왼쪽: 뒤로가기 버튼 -->
      <router-link
        v-if="backTo"
        :to="backTo"
        class="w-10 h-10 -ml-2 flex items-center justify-center rounded-full active:bg-slate-100 transition-colors"
      >
        <svg class="w-6 h-6 text-slate-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
      </router-link>
      <button
        v-else-if="showBack"
        @click="goBack"
        class="w-10 h-10 -ml-2 flex items-center justify-center rounded-full active:bg-slate-100 transition-colors"
      >
        <svg class="w-6 h-6 text-slate-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
      </button>
      <div v-else class="w-10 -ml-2"></div>

      <!-- 중앙: 타이틀 -->
      <h1 class="flex-1 text-center text-[17px] font-bold text-slate-900">{{ title }}</h1>

      <!-- 오른쪽: 액션 버튼 슬롯 또는 빈 공간 -->
      <div class="min-w-10 flex items-center justify-end">
        <slot name="right"></slot>
      </div>
    </div>
  </header>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'AppHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    backTo: {
      type: String,
      default: null
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const router = useRouter()

    const goBack = () => {
      router.back()
    }

    return {
      goBack
    }
  }
}
</script>
